import { Card, Col, Row, Table, Input } from 'antd';
import { useBranchVersion } from './query/useBranchVersion';
import CreateBranchVersion from './CreateBranchVersion';
import DeleteModalButton from '@/utils/components/DeleteModalButton';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { EditFilled, SearchOutlined } from '@ant-design/icons';
import { useDeleteApi } from '@/apiError/apiDelete';
import GlobalModal from '@/utils/modal/Modal';
import BranchVersionModal from './BranchVersionModal';
import { globalSearch } from '@/utils/search/Search';

const BranchVersionAssignmentList = () => {
  const { data, refetch } = useBranchVersion();
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [deleteReferenceId, setDeleteReferenceId] = useState(null);
  const [editReferenceId, setEditReferenceId] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalType, setModalType] = useState('');
  const { mutateAsync: deleteBranch, isPending: deleteLoading } =
    useDeleteApi();

  const deleteHandler = async () => {
    const data = await deleteBranch(
      `superadmin/branch-versions/${deleteReferenceId}/`,
    );
  };

  const showDeleteModal = (referenceId) => {
    setModalType('delete');
    setIsModalVisible(true);
    setDeleteReferenceId(referenceId);
  };

  const showEditModal = (referenceId) => {
    setIsOpen(true);
    setEditReferenceId(referenceId);
  };

  const columns = [
    {
      title: 'S.N.',
      align: 'center',
      render: (_, __, index) => index + 1,
      width: 50,
    },
    {
      title: 'Company',
      dataIndex: 'companyName',
      key: 'companyName',
      align: 'left',
    },
    {
      title: 'Branch',
      dataIndex: 'brachName',
      key: 'brachName',
      align: 'left',
    },
    {
      title: 'Version',
      dataIndex: 'version',
      key: 'version',
      align: 'left',
    },
    {
      title: 'Assigned By',
      dataIndex: 'assignBy',
      key: 'assignBy',
      align: 'left',
    },
    {
      title: 'Subscription Start Date',
      dataIndex: 'subscriptionStartYear',
      key: 'subscriptionStartYear',
      align: 'left',
      render: (value) => value?.split('T')[0],
    },
    {
      title: 'Subscription End Date',
      dataIndex: 'subscriptionEndYear',
      key: 'subscriptionEndYear',
      align: 'left',
      render: (value) => value?.split('T')[0],
    },
    {
      title: 'Remaining Days',
      dataIndex: 'remainingDays',
      key: 'remainingDays',
      align: 'right',
    },
    {
      title: 'Assigned At',
      dataIndex: 'assignAt',
      key: 'assignAt',
      align: 'left',
      render: (value) => value.split('T')[0],
    },
    {
      title: 'Action',
      key: 'action',
      width: 100,
      align: 'center',
      render: (_, record) => {
        return (
          <div className="tw-flex tw-item-center tw-justify-center tw-gap-4">
            <div
              onClick={() => showEditModal(record?.branchId)}
              className="ant-button-edit"
            >
              <Link to="" size="medium" className="edit">
                <EditFilled />
              </Link>
            </div>
            <DeleteModalButton
              showCancelModal={showDeleteModal}
              data={record?.branchId}
            />
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="table">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <Card
              variant="outlined"
              title={
                <CreateBranchVersion
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  refetch={refetch}
                />
              }
              extra={
                <div className="flex flex-col items-center justify-center">
                  <Input
                    className="header-search"
                    name="query"
                    value={searchQuery}
                    placeholder="Search..."
                    prefix={<SearchOutlined />}
                    onChange={(event) => setSearchQuery(event.target.value)}
                  />
                </div>
              }
            >
              <div className="overflow-x-auto">
                <Table
                  size="large"
                  bordered
                  tableLayout="auto"
                  onHeaderRow={() => ({
                    style: { whiteSpace: 'nowrap' },
                  })}
                  columns={columns?.map((col) => ({
                    ...col,
                    onCell: () => ({
                      style: {
                        padding: '6px 10px',
                      },
                    }),
                  }))}
                  scroll={{ x: true }}
                  className="ant-border-space"
                  style={{ textAlign: 'center', padding: '15px' }}
                  pagination={false}
                  dataSource={globalSearch(data?.data?.data, searchQuery) || []}
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      <GlobalModal
        isVisible={isModalVisible}
        type={modalType}
        onClose={() => setIsModalVisible(false)}
        onConfirm={async () => {
          await deleteHandler();
          refetch();
          setIsModalVisible(false);
        }}
        loading={deleteLoading}
      />

      <BranchVersionModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        refetch={refetch}
        id={editReferenceId}
        setEditReferenceId={setEditReferenceId}
      />
    </>
  );
};

export default BranchVersionAssignmentList;
